<template>
  <div class="transform-child-component-main">
      <div class="pbc-component-type-header">
        <div class="pbc-component-type-icon-parent">
          <alarm :size='16' class="pbc-component-type-icon" />
        </div>
        <div class="pbc-component-type-name">delay</div>
      </div>

      <div class="transform-child-component-summary">
        <div class="transform-child-component-text">Create after waiting</div>

        <display-or-edit v-model='transform.vars.delay' type='number' label="secs" :variables='variables' />

      </div>


    </div>

</template>
<script>
import DisplayOrEdit from '@ui/atoms/DisplayOrEdit.vue';
import GameVariables from '@edit/tree/gamevariables.js';
import Alarm from '@icons/Alarm.vue';
export default {
  props:{
    transform:{
      type:Object,
      required:true
    },
    parentTransform:{
      type:Object,
      required:true
    },
    transformsAndSource:{
      type:Object,
      required:true
    }
  },
  data() {
    const gameVariables = new GameVariables(this.transformsAndSource.gamedata);
    const variables = gameVariables.getVariablesForTransform(this.transformsAndSource, this.transform);
    if (typeof(this.transform.vars.delay) === 'undefined') {
      const delay = parseFloat(this.transform.vars.delay);
      this.$set(this.transform.vars, 'delay', isNaN(delay) ? 1 : delay);
    }
    return {
      variables,
      value:10
    }
  },
  components:{
    DisplayOrEdit,
    Alarm
  },
  methods:{
    onChange(in_nv, in_ov) {
      const type = 'vars';
      const nv = {
        delay: in_nv
      }
      const ov = {
        delay: in_ov
      }
      console.log('ON CHANGE IN DELAY THING', nv, ov);
      this.$emit("change", {
          nv,
          ov,
          type
      });
    }
  }
}
</script>
